import { Hand, MonitorPlay, Link2 } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const Techniques = () => (
  <section id="techniques" data-testid="techniques-section" className="py-20 lg:py-28 bg-brand-light">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <SectionHeading
        align="center"
        eyebrow="Inside the IQMIZE Routine"
        title="Simple techniques, practiced daily."
      />

      <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
        <Reveal>
          <div data-testid="technique-three-finger" className="h-full rounded-3xl border border-slate-200 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]">
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand text-white p-3">
              <Hand size={26} strokeWidth={1.8} />
            </div>
            <h3 className="mt-6 text-xl font-bold tracking-tight text-slate-900">The Three-Finger Technique</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              Gently bring the thumb, index and middle finger together on both hands while taking a few slow
              breaths — your personal focus cue: <span className="font-bold text-inavy">"Calm down. Focus now."</span>
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["Studying", "Recall practice", "Practice tests", "Examinations", "Moments of distraction"].map((t) => (
                <span key={t} className="rounded-full bg-brand-light px-3 py-1 text-xs font-bold text-brand">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div data-testid="technique-mental-screen" className="h-full rounded-3xl border border-slate-200 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]">
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-inavy text-white p-3">
              <MonitorPlay size={26} strokeWidth={1.8} />
            </div>
            <h3 className="mt-6 text-xl font-bold tracking-tight text-slate-900">The Mental Screen</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              Imagine important information clearly on an internal mental screen. Close your eyes, picture it,
              mentally read it — then recall the image when the question appears.
            </p>
            <div className="mt-5 rounded-xl bg-inavy px-5 py-4 text-center">
              <p className="text-xs uppercase tracking-[0.2em] font-bold text-igold">Example</p>
              <p className="mt-1 text-lg font-bold text-white">Area of a circle = πr²</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div data-testid="technique-memorable" className="h-full rounded-3xl border border-slate-200 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]">
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-igold text-slate-900 p-3">
              <Link2 size={26} strokeWidth={1.8} />
            </div>
            <h3 className="mt-6 text-xl font-bold tracking-tight text-slate-900">Make Learning Memorable</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              Instead of repeating information again and again, use visualization, imagination and meaningful
              connections. Give information meaning, imagery and story.
            </p>
            <div className="mt-5 rounded-xl bg-brand-light px-4 py-4">
              <p className="text-xs uppercase tracking-[0.2em] font-bold text-brand">Example</p>
              <p className="mt-1.5 text-xs font-bold leading-relaxed text-inavy">
                Mercury → Venus → Earth → Mars → Jupiter → Saturn → Uranus → Neptune
              </p>
              <p className="mt-1 text-xs text-slate-500">…transformed into a memorable mental story.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Techniques;
